import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Header from './header/Header'
import Footer from './footer/Footer'
import ListLand from '../page/list-land/ListLand'
import DetailLand from '../page/detail-land/DetailLand'
import './Layout.scss'
import AdminLand from '../page/admin-land/AdminLand'
import iconZalo from './zalo.png'

function Layout() {
  return (
    <div className='layout-container'>
        <Header></Header>
        <div className='layout-content'>
          <Routes>
            <Route path="/" element={<AdminLand isAdmin={false}/>} />
            <Route path="/detail/:id" element={<DetailLand />} />
            <Route path="/admin" element={<AdminLand isAdmin={true}/>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <Footer></Footer>
        <a href="https://zalo.me/0974352222" class="zalo-contact" target="_blank">
          <img src={iconZalo} alt="Liên hệ Zalo"/>
      </a>
    </div>
  )
}

export default Layout